import 'aos/dist/aos.css';

import AOS from 'aos';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useNav } from './routes';

const App = () => {
  const { element: routes } = useNav();

  const { pathname } = useLocation();

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <>{routes}</>;
};

export default App;
